export default class AuthorizationManager {

    isEditAuthorized(authEnum, collaborator) {

        if(collaborator.role == 'owner') {
            return true
        }

        return authEnum === 1
    }
}